module.exports = {
    jm: {
        tracking: {
            // Track events triggered by user
            // IsAsyncCapable: True
            // Called by: Entire app (during user clicking)
            // Request payload: DTO { trackingEventId, trackingEventName }
            createEvent: {url: '/svc/JlsService/Tracking/Event', method: 'POST'},

            // Save client side error trace
            // IsAsyncCapable: False
            // Called by: Entire app (during error handling)
            // Request payload: DTO { trace }
            // Response payload: aggregateDError
            reportClientError: {url: '/svc/JmGuruService/Tracking/ReportClientError', method: 'POST'} // TODO: Change to a generic endpoint instead of jmGuru
        },
    },
    cls: {
        // Login
        // IsAsyncCapable: False
        // Called by: LoginView
        // Request payload: DTO { username, password, client_id, grant_type, provider, scope, redirect_uri, auto_login, ui_locales }
        // Response payload: DTO { error_code }
        login: { url: '{clsAbsUrl}auth/v1/auth', method: 'POST' },

        // Register
        // IsAsyncCapable: False
        // Called by: RegisterView, RegisterPromoView
        // Request payload: DTO { username, password, client_id, grant_type, scope, redirect_uri, activate_email, auto_email, auto_login, ui_locales }
        // Response payload: DTO { error_code }
        register: { url: '{clsAbsUrl}auth/v1/signup', method: 'POST' },

        // Check if auto login available for user to know if "Keep me logged in" previously checked in this device and still not logged out
        // IsAsyncCapable: False
        // Called by: LoginView
        // Request payload: empty
        // Response payload: DTO { is_auto_login_available }
        tryAutoLogin: { url: '{clsAbsUrl}auth/v1/tryautologin', method: 'POST' },

        // Check if an email is already registered or not
        // IsAsyncCapable: False
        // Called by: RegisterView, RegisterPromoView
        // Request payload: DTO { username, client_id, }
        // Response payload: DTO { exists, has_password }
        isEmailExists: { url: '{clsAbsUrl}auth/v1/usernameexists', method: 'POST' },

        // Check if an email needs to be logged in through the federated way
        // IsAsyncCapable: False
        // Called by: LoginView, RegisterView, RegisterPromoView
        // Request payload: DTO { username, client_id, }
        // Response payload: DTO { federated_auth_required }
        isEmailFederated: { url: '{clsAbsUrl}auth/v1/federatedauthrequired', method: 'POST' },
    },
    localization: {
        // Localization resource
        // IsAsyncCapable: False
        // Called by: Localization
        // Response payload: Localization resource .json
        resource: { url: '{rootUrl}resources/localization/{culture}.json', method: 'GET' }
    }
};


/** WEBPACK FOOTER **
 ** ./src/constants/ajax-url.js
 **/